import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export function sendEmailContinueOnDesktop() {
  return fetchWrapper(endpoint + `/v1/email/continue-onboarding-on-desktop`, {
    method: 'post',
  }).then((res) => res.json());
}

export function sendEmailContractSigned(applicationId: string) {
  return fetchWrapper(endpoint + `/v1/email/contract-signed/${applicationId}`, {
    method: 'post',
  }).then((res) => res.json());
}
